import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FeaturesConfigModule, I18nModule } from '@spartacus/core';
import {
  AnonymousConsentDialogComponent,
  ConsentManagementModule,
  IconModule,
  KeyboardFocusModule,
  MessageComponentModule,
  SpinnerModule,
} from '@spartacus/storefront';

@Component({
  selector: 'app-gg-cookie-consent',
  templateUrl: './gg-cookie-consent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SpinnerModule,
    IconModule,
    AsyncPipe,
    I18nModule,
    ConsentManagementModule,
    NgIf,
    NgFor,
    MessageComponentModule,
    KeyboardFocusModule,
    FeaturesConfigModule,
  ],
})
export class GgCookieConsentComponent extends AnonymousConsentDialogComponent {}
